import { Injectable } from '@angular/core';
import { MultiselectProvider } from '../../multiselect-provider';
import { Observable, Observer } from 'rxjs';
import { MultiselectOptionItem, UiConstants } from '../../../util/core-utils';
import { Set } from 'immutable';
import { OrderType, QueryResult } from '../../util/services';
import { SmsTemplate, SmsTemplateService } from './sms-template.service';

@Injectable()
export class SmsTemplateMultiselectProvider implements MultiselectProvider {

  private multiselectQueryRequest: SmsTemplate.QueryRequest = {
    paging: {
      pageNumber: 1,
      numberOfItems: UiConstants.autocompletePageSize
    },
    noProgressBar: true,
    orders: Set.of({field: SmsTemplate.OrderField.NAME, type: OrderType.ASC}),
    disabled: undefined,
    name: undefined
  };

  constructor(private service: SmsTemplateService) {
  }

  load(queryRequest: SmsTemplate.QueryRequest): Observable<MultiselectOptionItem<number>[]> {
    return Observable.create((observer: Observer<MultiselectOptionItem<number>[]>) => {
      this.service.query(queryRequest).subscribe((result: QueryResult<SmsTemplate.SmsTemplate>) => {
        observer.next(result.items.map(item => this.toMultiselectOptionItem(item!)).toArray());
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  loadSmsTemplates(disabled?: boolean, query?: string): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign([], this.multiselectQueryRequest);
    queryRequest.disabled = disabled;
    queryRequest.name = query;
    return this.load(this.multiselectQueryRequest);
  }

  getById(id: number): Observable<MultiselectOptionItem<number>> {
    return Observable.create((observer: Observer<MultiselectOptionItem<number>>) => {
      this.service.get({
        id: id
      }).subscribe((result: SmsTemplate.SmsTemplate) => {
          observer.next(this.toMultiselectOptionItem(result!));
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  getByIds(ids: number[]): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign([], this.multiselectQueryRequest);
    queryRequest.id = Set.of(...ids);
    queryRequest.paging = undefined;
    return this.load(queryRequest);
  }

  toMultiselectOptionItem(item: SmsTemplate.SmsTemplate): MultiselectOptionItem<number> {
    const ret = new MultiselectOptionItem<number>();
    ret.id = item.id;
    ret.itemName = item.name;
    ret.disabled = item.disabled;
    return ret;
  }

}
